import { create } from 'zustand';

/**
 * UI state for Settings page.
 * This is CLIENT-ONLY state - no server data here.
 * Server data (providers, prompts) managed by React Query.
 */
interface SettingsUIState {
  // Selected items (just IDs, not full objects)
  selectedProviderId: number | null;
  selectedPromptId: string | null;

  // Edit mode flags
  isEditingProvider: boolean;

  // Collapsible section states
  systemPromptExpanded: boolean;
  userPromptExpanded: boolean;

  // Actions
  selectProvider: (id: number | null) => void;
  selectPrompt: (id: string | null) => void;
  setEditingProvider: (editing: boolean) => void;
  setSystemPromptExpanded: (expanded: boolean) => void;
  setUserPromptExpanded: (expanded: boolean) => void;
}

export const useSettingsUIStore = create<SettingsUIState>((set) => ({
  selectedProviderId: null,
  selectedPromptId: null,
  isEditingProvider: false,
  systemPromptExpanded: false,  // Collapsed by default when loading a prompt
  userPromptExpanded: false,    // Collapsed by default when loading a prompt

  selectProvider: (id) => set({ selectedProviderId: id }),
  selectPrompt: (id) => set({ selectedPromptId: id }),
  setEditingProvider: (editing) => set({ isEditingProvider: editing }),
  setSystemPromptExpanded: (expanded) => set({ systemPromptExpanded: expanded }),
  setUserPromptExpanded: (expanded) => set({ userPromptExpanded: expanded }),
}));
